import React from 'react';
import { makeStyles } from '@material-ui/core/styles';

import { useAction } from 'core/store/store';

import { makeResetPasswordOTPSubmitAction } from 'state/auth/actions';

import { PasswordResetCodeForm } from '../../../forms/PasswordResetCodeForm/PasswordResetCodeForm';
import { Resend } from './Resend';

const useStyles = makeStyles(theme => ({
    container: {
        height: '100%',
        paddingTop: theme.spacing(18),
        paddingBottom: theme.spacing(2),
        marginLeft: theme.spacing(2),
        marginRight: theme.spacing(2),
        textAlign: 'center',
        justifyContent: 'center',
        display: 'flex',
        flexDirection: 'column',
        [theme.breakpoints.up('sm')]: {
            justifyContent: 'space-between',
        },
    },
}));

export const CodeForm = () => {
    const action = useAction();
    const classes = useStyles();
    return (
        <div className={classes.container}>
            <PasswordResetCodeForm
                onSubmit={data => {
                    const { otp } = data;
                    action(makeResetPasswordOTPSubmitAction, otp);
                }}
            />
            <Resend />
        </div>
    );
};
